import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {getWindow} from 'ssr-window';
import {v4 as uuidV4} from 'uuid';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import EventListItem from 'event/EventListItem';
import QuickFilters from 'filters/QuickFilters';
import {toggleInfoPanelView} from '../search-actions';
import WithSearchControls from '../controls/WithSearchControls';
import SearchDateTimePickers from '../controls/SearchDateTimePickers';
import SearchActions from '../controls/SearchActions';
import SpotListBreadcrumbs from './SpotListBreadcrumbs';

const window = getWindow();

class SpotListSearchControlsEvent extends Component {
    static propTypes = {
        isMobile: PropTypes.bool,
        isAdmin: PropTypes.bool.isRequired,
        timezone: PropTypes.string.isRequired,
        isMonthly: PropTypes.bool,
        starts: PropTypes.string,
        ends: PropTypes.string,
        searchBounds: PropTypes.shape({
            swLat: PropTypes.number,
            swLng: PropTypes.number,
            neLat: PropTypes.number,
            neLng: PropTypes.number,
        }),
        isSearching: PropTypes.bool,
        isValidStart: PropTypes.bool,
        onDateTimeChange: PropTypes.func,
        onSearchClick: PropTypes.func,
        city: PropTypes.object.isRequired,
        destination: PropTypes.shape(DESTINATION_DATA).isRequired,
        event: PropTypes.object,
        numSpots: PropTypes.number.isRequired,
        breadcrumbs: PropTypes.object,
        showNoSpotsFound: PropTypes.bool,
        onToggleInfoPanel: PropTypes.func.isRequired,
        onToggleInfoModal: PropTypes.func,
    };
    state = {
        dateTimeKey: uuidV4(),
        showActions: false,
    };

    componentDidMount() {
        if (window.innerWidth < 900) {
            this.props.onToggleInfoPanel(false);
        }
    }

    _onActionsToggle = isShowing => {
        this.setState({
            showActions: isShowing,
        });
    };

    _onShowInfoClick = () => {
        const {isMobile, onToggleInfoPanel, onToggleInfoModal} = this.props;

        if (isMobile) {
            onToggleInfoModal();
        } else {
            onToggleInfoPanel(true);
        }
    };

    _onSuggestSelect = () => {
        this.setState({
            showActions: true,
        });
    };

    _onDateTimeChange = data => {
        this.setState({
            showActions: true,
        });

        this.props.onDateTimeChange(data);
    };

    _onSearchClick = () => {
        this.setState({
            showActions: false,
        });

        this.props.onSearchClick();
    };

    _onCancelClick = evt => {
        this.setState({
            dateTimeKey: uuidV4(),
            showActions: false,
        });
    };

    render() {
        const {
            isMobile,
            isAdmin,
            timezone,
            isMonthly,
            starts,
            ends,
            isSearching,
            isValidStart,
            breadcrumbs,
            city,
            destination,
            event,
            showNoSpotsFound,
            numSpots,
        } = this.props;
        const {dateTimeKey, showActions} = this.state;

        return (
            <div className="SpotListSearchControls">
                {!isMobile && (
                    <div className="SpotListSearchControls-info">
                        <SpotListBreadcrumbs data={breadcrumbs} />
                    </div>
                )}
                <EventListItem
                    city={city}
                    destination={destination}
                    event={event}
                    isMobile={isMobile}
                    showFindParking={false}
                    showVenue
                    showYear
                    onShowInfoClick={this._onShowInfoClick}
                />
                <div className="SpotListSearchControls-controls">
                    <SearchDateTimePickers
                        key={dateTimeKey}
                        isAdmin={isAdmin}
                        timezone={timezone}
                        isMonthly={isMonthly}
                        starts={starts}
                        ends={ends}
                        onChange={this._onDateTimeChange}
                    />
                    {showActions && (
                        <SearchActions
                            addKeyListeners={!isMobile}
                            showCancel
                            searchButtonText="Update Search"
                            isSearching={isSearching}
                            isValidStart={isValidStart}
                            onSearchClick={this._onSearchClick}
                            onCancelClick={this._onCancelClick}
                        />
                    )}
                </div>
                {numSpots > 0 && !showNoSpotsFound && !showActions && (
                    <QuickFilters
                        showReservationTypes={isMonthly}
                        visibleSlugs={['self-park', 'touchless']}
                        allowTouchlessTooltip
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = ({
    city: {data: city},
    destination: {data: destination},
    event: {data: event},
    filters: {numActive},
    search: {
        data: {breadcrumbs, searchType, showNoSpotsFound},
    },
}) => {
    return {
        city,
        destination,
        event,
        breadcrumbs,
        numActiveFilters: numActive,
        searchType,
        showNoSpotsFound,
    };
};

const mapDispatchToProps = {
    onToggleInfoPanel: toggleInfoPanelView,
};

const enhance = compose(
    WithSearchControls,
    connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(SpotListSearchControlsEvent);
